import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-cloud.mp4';
import DatacenterImage from '../../../assets/images/data-center.jpeg';
import CloudImage from '../../../assets/images/openspaceazure.jpg';
import './IntroSectionMigrationCloud.css';

const IntroSectionMigrationCloud2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-migration-cloud-2">
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('migrationCloud.introSection.optimization.title', 'Modernisez votre infrastructure')}</h2>
            <h3>{t('migrationCloud.introSection.optimization.description', 'Migrer votre infrastructure vers le cloud n\'est pas qu\'une simple tendance, c\'est une opportunité de modernisation et un puissant levier de transformation pour les entreprises.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('migrationCloud.introSection.videoNotSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('migrationCloud.introSection.planning.title', 'Des architectures optimisées')}</h2>
            <h3>{t('migrationCloud.introSection.planning.description', 'Avec l\'évolution rapide des technologies, la migration d\'infrastructure vous permet de bénéficier des technologies de pointe. Cela vous aide à rester compétitif dans à un environnement numérique en constante évolution.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={DatacenterImage}
              alt={t('migrationCloud.introSection.imageAlt', 'Security')}
            />
          </div>
        </div>
        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('migrationCloud.introSection.migration.title', 'Votre partenaire spécialisé.')}</h2>
              <h3>{t('migrationCloud.introSection.migration.description', 'IT Monkeys vous accompagne de A à Z dans cette transition, grâce à une approche personnalisée et des compétences reconnues dans la mise en place d\'environnements cloud.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('migrationCloud.introSection.imageAlt', 'Migration Cloud')}
              />
            </div>
          </div>
        </div>
        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionMigrationCloud2;
